import { Fragment, type CSSProperties, type ReactNode } from "react";

export interface DataCardValue {
    label?: string;
    value?: number | string;
}

export interface DataCardProps {
    title: string;
    data?: number | string | DataCardValue[];
    unit?: string;
    color?: string;
    titleBgColor?: string;
    tooltipContent?: string;
    children?: ReactNode;
}

/** 数据统计卡片，保留旧版标题、数值/单位分组及提示文案契约。 */
export function DataCard({
    title,
    data,
    unit,
    color = "#3370ff",
    titleBgColor = "#f3f8ff",
    tooltipContent,
    children
}: DataCardProps) {
    const valueList: DataCardValue[] = Array.isArray(data) ? data : [{ label: unit, value: data }];
    return (
        <div
            className="data-card-container"
            style={{ "--data-card-color": color, "--data-card-title-bg": titleBgColor } as CSSProperties}
            title={tooltipContent}
        >
            <div className="title">{title}</div>
            {children || (
                <div className="data-content">
                    {valueList.map((item, index) => (
                        <Fragment key={`${item.label || "value"}-${index}`}>
                            {item.value !== undefined && item.value !== "" ? (
                                <div className="num">{item.value}</div>
                            ) : null}
                            {item.label ? <div className="unit">{item.label}</div> : null}
                        </Fragment>
                    ))}
                </div>
            )}
        </div>
    );
}

export default DataCard;
